import React from "react";
import PropTypes from "prop-types";
import AuthService from "../../service/AuthService";
import appStyles from "../../styles/appStyles";
import { customStyles } from "../../styles/tableStyle";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { UploadFileOutlined } from "@mui/icons-material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import Disclaimer from "../other/Disclaimer";
import PolicyReminder from "../other/PolicyReminder";
import { appMessages } from "../../constants/appMessages";

const { Card, CardHeader, CardContent, CardActions, Button, LinearProgress, Divider,
  Typography, Box, RadioGroup, Radio, FormControlLabel, FormControl, InputLabel, Select, MenuItem,
  ToggleButtonGroup, ToggleButton, ListItemIcon,
  Icon,
  ListItemText } = require("@mui/material")
const { commons, util } = require("../../commons")
const { SnackBarWidget, DialogWidget } = require("../../Widget");


let configTabs = [


]
class Config extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      message: "",
      apiService: false,
      configFile: false,
      selectedFiles: [],
      uploadErr: "",
      selectedRadio: "",
      configTabId: "",
      configTabs: [],
      configTabError: false,
      inputKey: 0,
      showDialog: false
    };
  }

  componentDidMount() {
  }

  loadDefaults = () => {
    this.setState({ status: false, message: "" })
  }

  generateTabs = () => {
    this.setState({ configTabs: configTabs })

  }

  validateFile = (e) => {
    let { configFile } = this.state;
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    let uploadedFile = e.target.files[0];
    this.setState({ uploadErr: "", projectError: false, showDialog: false })
    let projectId = localStorage.getItem("projectId")
    if (projectId == '') {
      this.setState({ projectError: true })
      return;
    }
    if (!uploadedFile) {
      this.setState({ uploadErr: 'Please select file.' });
    }
    else if (uploadedFile && !validTypes.includes(uploadedFile.type)) {
      this.setState({ uploadErr: 'Please select valid file.' });
    }
    else if (uploadedFile && uploadedFile.type === "") {
      this.setState({ uploadErr: 'Please select valid file.' });
    }
    else this.setState({ configFile: uploadedFile, uploadErr: "" })
  }

  closeDialog = () => {
    this.setState({ showDialog: false });
  };

  openDialog = () => {
    let { showDialog } = this.state;
    this.setState({ showDialog: true });
  };
  validateTabFile = (e) => {
    let { selectedFiles } = this.state;
    let combinedFiles = [...selectedFiles, ...e.target.files]
    let validFiles = []
    const validTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel', 'application/xml', 'text/xml'];
    this.setState({ uploadErr: "", projectError: false, showDialog: false })

    combinedFiles.forEach(currentFile => {
      if (!validTypes.includes(currentFile.type)) {
        return;
      }
      else
        validFiles.push(currentFile)
    }
    );

    this.setState({ selectedFiles: validFiles })
  }
  fetchTags = async () => {
    this.setState({ uploadErr: "" })
    let { configFile, uploadErr, configTabId } = this.state;
    if (!configFile) {
      this.setState({ uploadErr: 'Please upload config file.' });
      return;
    }
    if (uploadErr.length) {
      return;
    }

    this.setState({ apiService: true })
    let data = new FormData();
    let projectId = localStorage.getItem("projectId")
    data.append('projectId', projectId);
    data.append('file', configFile);
    data.append('type', this.props.type.toLowerCase())
    data.append('op', 'getTab')

    try {
      commons.getAPIRes(data, "POSTFORMDATA", "rtltop").then(res => {
        this.setState({ apiService: false })
        if (!res.status) {
          this.setState({ message: res.errCode, status: true })
          setTimeout(function () {
            this.loadDefaults()
          }.bind(this), 2000)
        }
        if (res.status) {
          this.setState({ configTabs: res.result, configTabId: res.result[0] })
        }

      });

    } catch (error) {
      console.error('There was an error downloading the zip file!', error);
    }

  }
  resetForm = async () => {
    this.setState({ selectedFiles: [], uploadErr: "", inputKey: 0 })
  };


  handleConfigTab = (e) => {
    this.setState({ configTabId: e.target.value.toString() })
  }

  uploadConfig = () => {
    let { configFile, selectedFiles, configTabId } = this.state;
    if (!configFile) {
      this.setState({ uploadErr: "Please upload config file" })
      return;
    }
    if (!configTabId) {
      this.setState({ uploadErr: "Please select tab" })
      return;
    }
    if (!selectedFiles || !selectedFiles.length) {
      this.setState({ uploadErr: "Please upload tab file" })
      return;
    }

    this.openDialog();

  }
  downloadfile = () => {
    this.closeDialog()
    let { configFile, selectedFiles, configTabId } = this.state;
    let projectId = localStorage.getItem("projectId")

    this.setState({ apiService: true })
    let data = new FormData();

    data.append('op', 'uploadConfig')
    data.append('projectId', projectId);
    data.append('type', this.props.type.toLowerCase())
    data.append('tab', configTabId)
    // data.append('file', selectedFiles);
    data.append('configFile', configFile);
    for (let i = 0; i < selectedFiles.length; i++) {
      data.append('file', selectedFiles[i]);
    }
    try {
      commons.getAPIRes(data, "POSTFORMDATA", "rtltop").then(res => {
        this.setState({ apiService: false })
        if (res.logs)
          localStorage.setItem("newLogs", res.logs)
        this.props.loadLogs()
        if (!res.status) {
          this.setState({ message: this.props.type + appMessages.uploadFailMsg, status: false })
          setTimeout(function () {
            this.loadDefaults()
          }.bind(this), 2000)
        }
        if (res.status) {
          this.setState({ message: res.message ? res.message : this.props.type + appMessages.uploadSucMsg, status: true })

          const zipContent = atob(res.result);
          const zipBlob = new Blob([Uint8Array.from(zipContent, c => c.charCodeAt(0))], { type: 'application/zip' });
          const url = window.URL.createObjectURL(zipBlob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'files.zip');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }

      });
    } catch (error) {
      console.error('There was an error downloading the zip file!', error);
    }
  }




  render() {
    const { status, message, apiService, selectedFiles, uploadErr, selectedRadio,
      configTabId, handleConfigTab, configTabs, configTabError, generateTabs, showDialog } = this.state;

    return (
      <Box sx={{ alignContent: 'center' }}>
        <Card style={{ margin: "10px" }} sx={{
          bgcolor: 'background.paper',
          border: "none", boxShadow: "none",
          p: 2,
          minWidth: 300,
          // minHeight: 450
        }}>

          <CardContent>
            {apiService ? <LinearProgress /> : false}

            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="caption">Upload Config File &nbsp;</Typography>
              <FormControl fullWidth style={{ flex: 2 }}>
                <input type="file" onChange={(e) => this.validateFile(e)} />
              </FormControl>
              <Button style={{ justifyContent: 'end' }} onClick={(e) => this.fetchTags(e)}>Get Tabs</Button>
            </div>


            <br />

            {configTabs.length ? <FormControl fullWidth style={{ marginBottom: 10 }} error={configTabError}>
              <br />
              <InputLabel>Tabs</InputLabel>
              <Select value={configTabId} label="Tabs" onChange={(e) => this.handleConfigTab(e)} >
                {configTabs.map((item, index) =>
                  <MenuItem value={item.toString()} key={index}>{item.toString()}</MenuItem>
                )}

              </Select>
            </FormControl> : false}

            {configTabId && configTabId.length ?
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="subtitle1">Upload IPXACT files &nbsp;</Typography>
                <FormControl fullWidth style={{ flex: 1 }}>
                  <input type="file" onChange={(e) => this.validateTabFile(e)} />
                </FormControl></div> : false}

            <div>
              {selectedFiles.length > 0 && (
                <List>
                  {selectedFiles.map((file, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <UploadFileIcon />
                      </ListItemIcon>
                      <ListItemText>{file.name}</ListItemText>
                    </ListItem>
                  ))}
                </List>
              )}
            </div>
            {uploadErr.length ?
              <div style={{ display: 'flex', padding: 1 }}>
                <Typography color="error" variant="subtitle">
                  {uploadErr}
                </Typography> </div> : false}
          </CardContent>

          <CardActions style={{ justifyContent: "flex-end" }} >


            <Button variant="contained" color="primary"
              style={customStyles.successBtn}
              size="small" onClick={e => this.uploadConfig(e)}
            >
              Upload
            </Button>
          </CardActions>
          <Disclaimer />

        </Card>
        {
          showDialog ? (
            <DialogWidget
              maxWidth={"md"}
              dialogTitle={"Reminder"}
              dialogContent={
                <PolicyReminder

                />
              }
              okDialog={this.downloadfile}
              closeDialog={this.closeDialog}
              okTitle={"Continue"}
              negCancel={true}


            />
          ) : (
            false
          )
        }
        <SnackBarWidget message={message} status={status} />
      </Box >
    );
  }
}

Config.propTypes = {
  id: PropTypes.string,
  cancelDialog: PropTypes.func,
  reloadPage: PropTypes.func,
  action: PropTypes.string
};
export default Config;
